module.exports = __webpack_public_path__ + "static/media/ticket.06eba7dd.svg";